/**
 * Identyfikatory zakładek panelu administratora (§23 wiersz 11 „Panel administratora: konta,
 * role, backupy, importy, status zadań, audit security", etap 11 zadanie 1) — WYDZIELONE do
 * osobnego, lekkiego modułu z DOKŁADNIE tego samego powodu co `features/people/profile-tab-ids.ts`:
 * `router.tsx` musi znać zamknięty katalog dla `validateSearch` trasy `/admin`, a
 * `features/admin/AdminRoute.tsx` jest ładowany LENIWIE (`lazyRouteComponent`, §18.3) — statyczny
 * import stamtąd w `router.tsx` wciągnąłby cały panel administratora (w tym warstwę zapytań
 * backupów) do chunku powłoki.
 *
 * `backups` jest PIERWSZA i jest zakładką DOMYŚLNĄ — to jedyna w pełni zbudowana ta turę (etap
 * 10 zamknął backend, ta tura domyka interfejs). Pozostałe cztery (`accounts`/`audit`/`jobs`/
 * `imports`) są dziś WYŁĄCZNIE zaślepkami (`routes/PlaceholderScreen.tsx`) — ich kolejność
 * odpowiada literalnemu wyliczeniu zlecenia tego zadania („Konta, Audyt, Zadania, Importy"), nie
 * kolejności z wireframe §7.3 (tamten szkic ma inny, mniejszy zestaw czterech zakładek bez
 * „Zadania" — nie jest tu odtwarzany co do joty, bo to zadanie wprost poszerza katalog do pięciu
 * zakładek §23).
 */
export const ADMIN_TAB_IDS = ['backups', 'accounts', 'audit', 'jobs', 'imports'] as const;
export type AdminTabId = (typeof ADMIN_TAB_IDS)[number];

export function isAdminTabId(value: unknown): value is AdminTabId {
  return typeof value === 'string' && (ADMIN_TAB_IDS as readonly string[]).includes(value);
}
